module.exports = {"210802001":"八田地街道","210802002":"建丰街道","210802003":"建设街道","210802004":"跃进街道","210802007":"新建街道","210802008":"东兴街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210802.json
// module id = 646
// module chunks = 0